import React from 'react';
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section6ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),
        headingSection1_1: stringsTranslate(appWords.building_loyalty),
        subheadingSection1_1:  stringsTranslate(appWords.use_as_loyalty_tool),
        headingSection1_2: stringsTranslate(appWords.what_makes_knaek_unique),
        subheadingSection1_2_1: stringsTranslate(appWords.focus_on_local_visibility),
        subheadingSection1_2_2: stringsTranslate(appWords.student_funded_affordability),

        headingSection1_3: stringsTranslate(appWords.good_to_know),
        subheadingSection1_3_1: stringsTranslate(appWords.you_control_campaign),
        subheadingSection1_3_2: stringsTranslate(appWords.you_decide_coupon_amount),
        subheadingSection1_3_3: stringsTranslate(appWords.adjust_and_track_results),
        subheadingSection1_3_4: stringsTranslate(appWords.no_commission_or_hassle),
        playImg1: "/assets/images/ForCompanies/schermen 1.webp",
    }

    return (
        <section className="section " id='loyalty'>
            <div className="container-fluid">
                {/*Section 6*/}

                <div className="row justify-content-center align-items-center px-2 px-md-5 px-lg-5 ">

                    {/*1-1*/}
                    <div className="col-lg-12 col-md-12 flex-wrap d-flex align-items-center mt-5 list ">
                        <h1 className="pr-5 heading-section6-for-companies text-knaek-title">{initStrings.headingSection1_1}</h1>
                        <p className="mt-2 p-1 line-text text-knaek-title subheading-section6-for-companies ">{initStrings.subheadingSection1_1}</p>
                    </div>

                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-0 mt-lg-5 mt-md-5 list">

                        {/*1-2*/}
                        <h1 className="pr-0 pr-lg-5 pr-md-5 heading-section6-for-companies text-knaek-title">{initStrings.headingSection1_2}</h1>
                        <p className="pr-0 pr-lg-5 pr-md-5 mt-2 p-1 line-text text-knaek-title subheading-section6-for-companies">{initStrings.subheadingSection1_2_1}</p>
                        <p className="pr-0 pr-lg-5 pr-md-5 mt-2 p-1 line-text text-knaek-title subheading-section6-for-companies">{initStrings.subheadingSection1_2_2}</p>


                        {/*1-3*/}
                        <h1 className="pr-0 pr-lg-5 pr-md-5 mt-5 heading-section6-for-companies text-knaek-title">{initStrings.headingSection1_3}</h1>
                        <ul>
                            <li className={"ml-2 line-text text-knaek-title subheading-section6-for-companies pr-0 pr-lg-5 pr-md-5"}>
                               {initStrings.subheadingSection1_3_1}
                            </li>
                            <li className={"ml-2 line-text text-knaek-title subheading-section6-for-companies pr-0 pr-lg-5 pr-md-5"}>
                               {initStrings.subheadingSection1_3_2}
                            </li>
                            <li className={"ml-2 line-text text-knaek-title subheading-section6-for-companies pr-0 pr-lg-5 pr-md-5"}>
                                {initStrings.subheadingSection1_3_3}
                            </li>
                        </ul>
                        <p className="mt-2 p-1 pr-0 pr-lg-5 pr-md-5 line-text text-knaek-title subheading-section6-for-companies">{initStrings.subheadingSection1_3_4}</p>
                    </div>

                    <div className="col-lg-6 col-md-12 text-center mt-5 mt-lg-0 mt-md-0">
                        <img src={initStrings.playImg1} className={"w-100"} alt={""}/>
                    </div>

                </div>
            </div>
        </section>
    );

}
